// import emHome from "@/views/em/Home";

import emAssistantRoutersJsc from "@/router/emAssistant/jsc/moduleIndex-router-emAssistant-jsc";


export default [
    // {path: "/em", name: "emHome", component: emHome},
    ...emAssistantRoutersJsc
]
